import { render, staticRenderFns } from "./RemissionView.vue?vue&type=template&id=12b71f3a&scoped=true"
import script from "./RemissionView.vue?vue&type=script&lang=js"
export * from "./RemissionView.vue?vue&type=script&lang=js"
import style0 from "./RemissionView.vue?vue&type=style&index=0&id=12b71f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b71f3a",
  null
  
)

export default component.exports